import ReturnSourceType from "@constant/ReturnSourceType";
import buildUrl from "@utils/buildUrl";

/**
 * 組合「建立退貨單」頁面的網址。
 * @param sourceType 退貨來源模組類型
 * @param orderId 來源訂單 id
 * @param subOrderId 選填，來源子訂單 id（訂單內容子訂單來源才需要）
 * @returns 建立退貨單頁面的相對路徑
 */
export function buildReturnProductAppCreateUrl(
  sourceType: ReturnSourceType,
  orderId: number,
  subOrderId?: number,
): string {
  return buildUrl(["return-product-management", "new", sourceType, orderId], { subOrderId });
}

/**
 * 組合退貨單詳情頁的網址。
 * @param returnOrderId 退貨單 id
 * @returns 退貨單詳情頁的相對路徑
 */
export function buildReturnProductAppDetailUrl(returnOrderId: number): string {
  return buildUrl(["return-product-management", returnOrderId]);
}
